import React from 'react';
import Form from './Form'; // Reusable Form component
import { submitToHubSpot } from '../../utils/submitToHubSpot';
import * as styles from "./FormsStyles/PopupForm.module.css"

const PopupForm = () => {
  const portalId = '46102677'; // Your HubSpot Portal ID
  const formId = 'b68c5638-0b91-4a5b-a91e-30b41b6b5559'; // Replace with your unique HubSpot Form ID

  const fields = [
    { label: 'First Name', name: 'firstname', required: true, placeholder: true },
    { label: 'Last Name', name: 'lastname', required: true, placeholder: true },
    { label: 'Company', name: 'company', required: true, placeholder: true },
    { label: 'Job Title', name: 'jobtitle', required: true, placeholder: true },
    { label: 'Email', name: 'email', type: 'email', required: true, placeholder: true },
  ];

  const handleSubmit = async (data) => {
    const fieldsToSubmit = Object.entries(data).map(([name, value]) => {
      return { name, value };
    });

    // Submit to HubSpot
    await submitToHubSpot(fieldsToSubmit, portalId, formId);
  };

  return (
    <div className="popup-form-container">
      <div className={`${styles.title} font-bold font-circular text-white`}>Stay Connected with The Millennium Alliance</div>
      <div className={`${styles.subtitle} font-regular font-circular text-white`}>Subscribe for exclusive insights, leadership opportunities, and updates on our latest events. Join our global network industry leaders.</div>
      <Form
        fields={fields}
        handleSubmit={handleSubmit}
        className={styles.popupForm}
        submitButtonLabel="Subscribe"
      />
    </div>
  );
};

export default PopupForm;
